// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aWvqY","comment":"styles_comment__-Ebzh"};